/* Keep the two drop items in sync without deleting unrelated cart items. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.MessDrop02Cart = factory();
})(typeof window === 'undefined' ? globalThis : window, function () {
  'use strict';
  class CartError extends Error {
    constructor(code, message) { super(message || code); this.code = code; }
  }
  async function prepare(options) {
    const request = options.fetch || fetch;
    const base = (options.root || '/').replace(/\/?$/, '/');
    const allIds = options.products.map(p => String(p.id)).filter(id => id !== 'null' && id !== '0');
    const wanted = options.selected.map(String);
    if (!wanted.length || wanted.some(id => !allIds.includes(id))) throw new CartError('selection');
    async function call(path, payload) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await request(base + path, {
          method: payload ? 'POST' : 'GET', credentials: 'same-origin',
          headers: { 'Accept': 'application/json', ...(payload ? {'Content-Type': 'application/json'} : {}) },
          body: payload ? JSON.stringify(payload) : undefined, signal: controller.signal
        });
        let data;
        try { data = await response.json(); } catch (_) { throw new CartError('network'); }
        if (!response.ok) throw new CartError(response.status === 422 ? 'stock' : 'network');
        return data;
      } catch (error) {
        if (error instanceof CartError) throw error;
        throw new CartError('network');
      } finally { clearTimeout(timer); }
    }
    let cart = await call('cart.js');
    if (!Array.isArray(cart.items)) throw new CartError('network');
    const updates = {}, retained = new Set();
    cart.items.forEach(item => {
      const id = String(item.variant_id);
      if (!allIds.includes(id)) return;
      const quantity = wanted.includes(id) && !retained.has(id) ? 1 : 0;
      if (quantity) retained.add(id);
      if (quantity !== item.quantity) updates[item.key] = quantity;
    });
    if (Object.keys(updates).length) await call('cart/update.js', {updates});
    const missing = wanted.filter(id => !retained.has(id));
    if (missing.length) await call('cart/add.js', {items: missing.map(id => ({id, quantity: 1}))});
    cart = await call('cart.js');
    const counts = new Map();
    (cart.items || []).forEach(item => {
      const id = String(item.variant_id);
      if (allIds.includes(id)) counts.set(id, (counts.get(id) || 0) + item.quantity);
    });
    if (allIds.some(id => (counts.get(id) || 0) !== (wanted.includes(id) ? 1 : 0))) throw new CartError('stock');
    return cart;
  }
  return {prepare, CartError};
});
